import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const resolverRef = useRef(null);
  const { t } = useTranslation('common');

  const confirm = useCallback((message, options = {}) => (
    new Promise((resolve) => {
      resolverRef.current = resolve;
      setDialog({
        message,
        title: options.title || t('confirm.title'),
        confirmLabel: options.confirmLabel || t('confirm.confirmLabel'),
        cancelLabel: options.cancelLabel || t('confirm.cancelLabel'),
        danger: options.danger !== false,
      });
    })
  ), [t]);

  const respond = useCallback((result) => {
    setDialog(null);
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (!dialog) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') respond(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [dialog, respond]);

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {dialog && (
        <div className="modal-overlay" onClick={() => respond(false)}>
          <div className="card modal-content confirm-modal" role="alertdialog" aria-modal="true" onClick={(event) => event.stopPropagation()}>
            <h3>{dialog.title}</h3>
            <p>{dialog.message}</p>
            <div className="modal-actions">
              <button type="button" className="text-btn" onClick={() => respond(false)}>{dialog.cancelLabel}</button>
              <button type="button" autoFocus className={`primary-btn${dialog.danger ? ' danger-btn' : ''}`} onClick={() => respond(true)}>{dialog.confirmLabel}</button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
}

export function useConfirm() {
  return useContext(ConfirmContext);
}
